// segment
export const BLOCKER_VIEWED = 'Daily Limit - Blocker Viewed';
export const BOTTOMSHEET_VIEWED = 'Daily Limit - Bottom Sheet Viewed';
export const BLOCKER_DISMISSED = 'Daily Limit - CLX Blocker Dismissed';
export const BOTTOMSHEET_GOT_IT = 'Daily Limit - Got it Clicked';
export const GET_SUBSCRIPTION = 'Daily Limit - Get subscription clicked';
export const LIMIT_EXHAUSTED = 'Daily Limit - Limit Exhausted';

// list of goals for limiting class consumption
export const LIMITING_TIME_CONSUMPTION_GOALS = [
  // prod goal uid
  'JAQRK',
  'QGFRK',
  'PZSIU',
  'NVLIA',
  // gammma goal uid
  'PESHE',
  'YAHCG',
  'WKOGR',
  'VIDUE',
  'JIWEO',
  'KSCGY',
  'TMUVD',
  'VLEMN',
  'YOTUH',
  'LVECA',
  'RTPSX',
  'ZIUBD',
  'GNFFE',
  'SDDOC',
  'TEWDQ',
  'IEIJT',
  'XTKHH',
  'RXRWJ',
  'TUNWK',
  'RJVOD',
  'PLWCX',
  'RUJGA',
  'BBKWG',
  'XNDUS',
  'QOIVT',
  'CKTCQ',
  'GWDPV',
  'ZYCWC',
  'DANNJ',
  'GSZGO',
  'JWBRG',
  'UQCMN',
  'BIZXQ',
  'SCTBY',
  'EJTZD',
  'TPSBK',
  'GWDPZ',
  'BDNTN',
  'XCTVJ',
  'ZISFF',
  'WKQWQ',
  'NYHNH',
  'QKHZF',
  'SCANJ',
  'QJEJG',
  'GMXMZ',
  'SUVLV',
  'MRZFY',
  'SIFWL',
  'FDGQK',
  'PPPOX',
  'KNMDN',
  'RYNDN',
  'FIYVI',
  'SASYW',
  'TICPI',
  'GUVHW',
  'EUDWC',
  'JUYYX',
  'BVHCS',
  'LFUWW',
  'TZNQX',
  'RJDNO',
  'XFOIT',
  'KVBFU',
  'CVGGX',
  'TNOJW',
  'WWKAS',
  'ZDYHU',
  'UMTAN',
  'LOPPY'
];
export const CLASS_BLOCKER_ID = 'CLASS_BLOCKER_ID';

export const POST_CLASS_RECOMMENDATION_EXP = 'web_post_class_recommendation_ab';
